import roles from "@/roles";
export default [
  {
    icon: "account_box",
    title: "Clients",
    roles: [roles.ADMIN, roles.CLIENT_ADMIN, roles.BETA_FEATURE],
    children: [
      {
        icon: "account_box",
        router: true,
        roles: [roles.ADMIN, roles.CLIENT_ADMIN],
        title: "Users",
        to: "Users"
      },
      {
        icon: "settings",
        router: true,
        roles: [roles.ADMIN, roles.BETA_FEATURE],
        title: "Client Settings",
        to: "ClientSettings"
      }
    ]
  }
];
